module.exports = __webpack_public_path__ + "img/reservation_gift4.6c1e1121.png";